import { ConfigDispatcher as SourceConfigDispatcher } from 'SourceStore/Config/Config.dispatcher';
import ConfigQuery from 'Query/Config.query';
import RegionQuery from 'Query/Region.query';
import ReviewQuery from 'Query/Review.query';
import BrowserDatabase from 'Util/BrowserDatabase';
import { ONE_MONTH_IN_SECONDS } from 'Util/Request/QueryDispatcher';
import { updateConfig } from 'Store/Config/Config.action';

export class ConfigDispatcher extends SourceConfigDispatcher {
    onSuccess(data, dispatch) {
        if (data) {
            const { customerAdditionalAttributes } = data;
            for (const [key, value] of Object.entries(customerAdditionalAttributes)) {
                customerAdditionalAttributes[key] = JSON.parse(value);
            }
            BrowserDatabase.setItem(data, 'config', ONE_MONTH_IN_SECONDS);
            dispatch(updateConfig(data));
        }
    }

    prepareRequest() { // added getCustomerAttributes, getGTMConfiguration, getFreeShipping
        return [
            RegionQuery.getCountriesQuery(),
            ReviewQuery.getRatingQuery(),
            ConfigQuery.getQuery(),
            ConfigQuery.getCheckoutAgreements(),
            ConfigQuery.getCustomerAttributes(),
            ConfigQuery.getGTMConfiguration(),
            ConfigQuery.getFreeShipping(),
            ConfigQuery.getPromoData(),
            ConfigQuery.getCmsLIO(),
            ConfigQuery.getCartRuleSpecialPriceData(),
            ConfigQuery.getNewsletterConfig(),
            ConfigQuery.getStickerNotificationsData(),
            ConfigQuery.getProductCardStickerData(),
            ConfigQuery.getFeaturesConfig(),
            ConfigQuery.getEasyBoxAllowCodConfig(),
            ConfigQuery.getPopupInformationConfig(),
            ConfigQuery.getExcludedProducts(),
            ConfigQuery.getPointsExcludedProducts(),
            ConfigQuery.getCmsBlockNotificationId(),
            ConfigQuery.getLoyaltyConfigData(),
            ConfigQuery.getLotteryConfig(),
            ConfigQuery.getOgImageUrl(),
            ConfigQuery.getPromoItemsForPopup(),
            ConfigQuery.getPayuV(),
            ConfigQuery.getHouseholdSkuList(),
        ];
    }
}

export default new ConfigDispatcher();
